enum events {
    EDIT_COUNTDOWN_TIMER = 'edit-countdown-timer',
    EDIT_COUNTDOWN_TIMER_CLOSE = 'edit-countdown-timer-closed',
}
  
export default events